import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'services/config';
import type { Attachment, AttachmentParams } from '@/models/attachment';
import { Pagination } from '@/models';
import { buildQueryString, prepareHeaders } from '@/state/slices/index';

export const AttachmentsAPI = createApi({
  reducerPath: 'attachmentsAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_URL,
    prepareHeaders,
  }),
  tagTypes: ['Attachment'],
  endpoints: (builder) => ({
    getAttachments: builder.query<Pagination<Attachment>, AttachmentParams>({
      query: (params) => {
        const queryString = buildQueryString(params as Record<string, string>);
        return {
          url: `/attachments/${queryString}`,
          method: 'GET',
        };
      },
      providesTags: (result) =>
        result
          ? [
              { type: 'Attachment', id: 'LIST' },
              ...result.results.map((a) => ({
                type: 'Attachment' as const,
                id: a.uuid,
              })),
            ]
          : [{ type: 'Attachment', id: 'LIST' }],
    }),
  }),
});

export const { useGetAttachmentsQuery } = AttachmentsAPI;
